<template>
  <div>
    <custom-callout
      class="mt-4"
      :border-color="'primary-2'"
      :status-color="'blue'"
      :has-toggle="false"
    >
      <icon-view
        :has-border="false"
        icon="fas fa-plus-circle color-orange mb-1"
        icon-size="17px"
        title="Cargar Mes"
        variant="custom-icon-view"
      />
      <br />
      <validation-observer ref="formDateObserver">
        <div class="row pb-4">
          <div class="col-md-4 col-sm-12">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                :options="yearList"
                label="Año:"
                fieldkey="id"
                fieldname="name"
                v-model="year"
                :error="errors[0]"
                placeholder="Seleccione"
                custom-error-msg="El año es requerido."
              />
            </validation-provider>
          </div>
          <div class="col-md-4 col-sm-12">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                :options="getMonthList"
                label="Mes:"
                fieldkey="monthNumber"
                fieldname="monthName"
                v-model="month"
                placeholder="Seleccione"
                :error="errors[0]"
                custom-error-msg="El mes es requerido."
              />
            </validation-provider>
          </div>
          <div class="col-md-4 col-sm-12">
            <br />
            <div class="mt-2">
              <action-button
                class="button-size"
                id="modal-btn-cancelar"
                variant="outline-danger btn-cancel  mr-3"
                type="button"
                i="fas fa-times-circle"
                @click="cancelEvent"
              >
                Cerrar
              </action-button>
              <action-button
                class="button-size"
                id="modal-btn-cancelar"
                variant="success btn-green"
                type="button"
                i="fas fa-arrow-circle-right"
                @click="continueEvent"
              >
                Continuar
              </action-button>
            </div>
          </div>
        </div>
      </validation-observer>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout'
import CustomDropDown from 'custom-drop-down'
import ActionButton from 'ActionButton'
import IconView from 'icon-view'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import allMonth from '@/utils/constants/listAllMonth'
export default {
  name: 'CustomMonthChargerComponent',
  components: {
    CustomCallout,
    CustomDropDown,
    ValidationObserver,
    ValidationProvider,
    ActionButton,
    IconView,
  },
  props: {
    yearList: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    year: null,
    month: null,
  }),
  computed: {
    getMonthList() {
      return allMonth.LISTMONTH
    },
  },
  methods: {
    async continueEvent() {
      const isValid = await this.$refs.formDateObserver.validate()
      if (isValid) {
        this.$emit('continue-event', { year: this.year, month: this.month })
      }
    },
    cancelEvent() {
      this.$emit('cancel-event')
    },
  },
}
</script>

<style scoped>
.button-size {
  height: 37px;
  width: 136px;
}
</style>
